export default class CustModel {
    constructor({ id, name, name_company, email, phone, quetion_id, answer_id, score, created_on }) {
        this.id = id;
        this.name_rater = name;
        this.name_company = name_company;
        this.email = email;
        this.no_hp = phone;
        this.quetion_id = quetion_id;
        this.answer_id = answer_id;
        this.score = score;
        this.created_on = created_on;
    }
}